import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Paging } from '../../../model/paging/paging';
import { IPD } from '../../../model/ipd/ipd';

@Injectable({
    providedIn: 'root'
})
export class IPDService_Mock {
    GETPaginatedIPDs(paging:Paging): Observable<IPD>  | any{
        const allData = this.getMockIPDs();
        const start = (paging.pageIndex - 1) * paging.pageSize;
        const end = start + paging.pageSize;
        const pageData = allData.slice(start, end);
        const mockData = {
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 12,
            data: {
                count: allData.length,
                items: pageData
            }
        };

        return of(mockData);
    }

    GETIPDById(ipdId:number): Observable<IPD>  | any{
        const ipd = this.getMockIPDs().find((item) => item.IPDId === ipdId) ?? this.getMockIPDs()[0];

        const mockData = {
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 8,
            data: {
                name: ipd?.name ?? '',
                note: ipd?.note ?? '',
                gainLoss: ipd?.gainLoss ?? { freq_24: 0, freq_5: 0, freq_6: 0 },
                components: ipd?.components ?? []
            }
        };

        return of(mockData);
    }


    DELETEIPD(ipdId:number){
        const mockResponse = {
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 7,
            data: true
        };

        return of(mockResponse);
    }   

    POSTIPD(body:IPD){
        const mockResponse = {
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 9,
            data: true
        };

        return of(mockResponse);
    }

    PUTIPD(ipdId:number, body:IPD){
        const mockResponse = {
            success: true,
            errorCode: 0,
            errorMessage: null,
            elapsed: 9,
            data: true
        };

        return of(mockResponse);
    }

    private getMockIPDs() {
        return [
            {
                IPDId: 1,
                name: "IPD 1",
                note: "Main IPD",
                gainLoss: { freq_24: 1.2, freq_5: 2.1, freq_6: 2.8 },
                components: [
                    { code: "C1", value: 100 },
                    { code: "R1", value: 220 }
                ]
            },
            {
                IPDId: 2,
                name: "IPD 2",
                note: "Backup IPD",
                gainLoss: { freq_24: 1.0, freq_5: 1.8, freq_6: 2.4 },
                components: [
                    { code: "C2", value: 150 }
                ]
            },
            {
                IPDId: 3,
                name: "IPD Directional",
                note: "Directional branch for floor two.",
                gainLoss: { freq_24: 0.9, freq_5: 1.6, freq_6: 2.2 },
                components: [
                    { code: "L1", value: 47 },
                    { code: "R8", value: 330 }
                ]
            }
        ];
    }
}
